module.exports = __webpack_public_path__ + "media/components/images/panels/8-b-76fdc7bfba8bd302d5414cd8c5787f89.jpeg";